import TrickSelector from '@/components/game/scenes/TrickSelector';
import StatusMeters from '@/components/game/sidebar/StatusMeters';

export default [
	{
		path: 'trick-selector',
		name: "TRICK_SELECTOR",
		components: {
			gameSpace: TrickSelector,
			sidebar: StatusMeters,
		},
		meta: {
			transition: "curtain-pan",
		},
	},
	{
		path: 'trick-selector/complete',
		async beforeEnter(to, from, next) {
			next({ path: "/game/performance" });
		},
	},
];



// WEBPACK FOOTER //
// ./src/router/trick-selector.routes.js